<template>
  <main
    class="
      d-flex
      container-fluid
      flex-column
      align-items-center
      justify-content-center
      p-0
      m-0
    "
  >
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <div class="w-100 mt-2">
       <AlertMessageComponent/>
    </div>
    <b-row class="container-fluid h-100 p-0 m-0 main-content">
      <b-col
        class="col-lg-9 left-container d-flex flex-column align-items-center pb-3 pb-lg-0"
      >
        <!-- Post area -->
        <b-container
          class="
            h-100
            w-100
            d-flex
            flex-column
            align-items-center
            justify-content-center
          "
        >
          <b-container class="mb-5 mt-3 mt-lg-0">
            <h4 class="text-center main-header font-weight-bold">
              倉庫の自動化をもっと身近に簡単に
            </h4>
            <h5 class="text-center sub-header">
              物流倉庫の庫内効率化情報を発信します
            </h5>
          </b-container>
          <!-- Post slider -->
          <b-row class="d-flex align-items-center justify-content-center">
            <button
              class="
                btn btn-carousel
                d-flex
                align-items-center
                justify-content-center
                border-0
                mr-4
              "
              @click="prev"
            >
              <i class="material-icons">keyboard_arrow_left</i>
            </button>
            <b-carousel
              class="slide-area w-75"
              id="carousel"
              v-model="slide"
              :interval="4000"
              ref="carousel"
            >
              <b-carousel-slide
                v-for="(post, index) in posts"
                v-bind:key="index"
                @click.native="openLink(index)"
                class="cursor-pointer"
              >
                <template #img>
                  <b-container>
                    <b-row class="slide-container">
                      <b-col
                        class="
                          d-flex
                          col-6
                          align-items-center
                          justify-content-center
                          image-container
                        "
                      >
                        <img
                          class="slide-image img-fluid"
                          v-bind:src="post.postImg"
                          alt="Post picture"
                        />
                      </b-col>
                      <b-col class="post col-6 pr-4">
                        <b-row class="post-title mt-4">
                          <h6>
                            {{ post.title }}
                          </h6>
                        </b-row>
                        <b-row class="post-category mt-1 text_blue">
                            <strong>{{ post.category }}</strong>
                        </b-row>
                        <b-row class="content text_gray mt-2">
                          <p>
                            {{ post.content }}
                          </p>
                        </b-row>
                        <b-row class="d-flex post-profile">
                          <b-col class="col-auto mr-2 author-img">
                            <img v-bind:src="post.avatar" alt="Avatar" />
                          </b-col>
                          <b-container class="col-6 post-info">
                            <p class="published-date text-size-12">
                              {{ post.published_date }}
                            </p>
                            <p class="author-name text_gray text-size-12">
                              {{ post.author }}
                            </p>
                          </b-container>
                          <b-container class="col-3 post-logo">
                            <img
                              src="../assets/logo/+a_media_logo.svg"
                              alt="+aMedia logo"
                            />
                          </b-container>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-container>
                </template>
              </b-carousel-slide>
            </b-carousel>
            <button
              class="
                btn btn-carousel
                d-flex
                align-items-center
                justify-content-center
                border-0
                ml-4
                algin-button-carousel
              "
              @click="next"
            >
              <i class="material-icons">keyboard_arrow_right</i>
            </button>
          </b-row>
        </b-container>
      </b-col>
      <!-- Login area -->
      <b-col class="card_wrap col p-0 right-container">
        <b-container
          fluid
          class="
            p-0
            h-100
            w-100
            d-flex
            flex-column
            align-items-center
            justify-content-center
          "
        >
          <img
            src="../assets/logo/+hub_logo_yoko_black_background.svg"
            alt="+hub_logo_yoko"
            class="logo mt-5"
          />
          <div class="entra-login px-5 w-100">
            <p class="text-center text_black pb-3">すべての+Hubサービスにログインします</p>
            <b-button
              type="submit"
              variant="info"
              class="btn-submit d-flex align-items-center justify-content-center"
              @click="onClickLoginWithEntra"
            >
              スタート
              <span class="material-icons material-icons-outlined">
                keyboard_arrow_right
              </span>
            </b-button>
          </div>
          <div class="w-100 px-5">
            <div class="normal-login text_gray" @click="handleSysLoginMode">
              <span
                class="material-icons"
              >{{ isNormalLoginMode ? 'arrow_drop_down' : 'arrow_right' }}</span>
              <span class="text_gray">+Hub BASEアカウントでログインの場合</span>
            </div>
          </div>
          <b-row
            class="d-flex align-items-center px-5 w-100"
          >
            <span class="pl-0 mb-3">
              <div
                v-bind:class="{
                  'error-message mb-10 text-nowrap': true,
                  'pl-0': !this.isLoginMode
                }"
              >
              </div>
            </span>
          </b-row>
          <!-- Login Mode -->
          <b-row
            class="d-flex align-items-center justify-content-center px-5 w-100"
            v-if="isLoginMode && isNormalLoginMode"
          >
            <validation-observer ref="validationLoginForm" @submit.prevent="onClickLogin" class="w-100">
              <b-form
                class="submit-form"
              >
                <validation-provider
                  name="ユーザー名"
                  rules="required"
                  mode="passive"
                  v-slot="{ errors }"
                >
                  <b-form-group id="username-group">
                    <input-text-component
                      classCustom="w-100"
                      id="username"
                      :autofocus="true"
                      :maxlength="50"
                      :placeholder="`ログインIDまたはメールアドレス`"
                      v-model="form.username"
                      :state="errors && errors.length ? true : false"
                      @blur="cleanValidity('username')"
                    />
                    <p class="error-message mb-10 text-nowrap">
                      {{ errors[0] ? 'ログインIDを入力してください。' : '' }}
                    </p>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="パスワード"
                  rules="required"
                  mode="passive"
                  v-slot="{ errors }"
                >
                  <b-form-group id="password-group-">
                    <b-form-input
                      id="password"
                      type="password"
                      v-model="form.password"
                      placeholder="パスワード"
                      maxLength="20"
                      v-bind:class="{ 'border-danger bg-danger-outline': errors[0] }"
                    ></b-form-input>
                    <p class="error-message mb-10 text-nowrap">
                      {{ errors[0] ? 'パスワードを入力してください。' : '' }}
                    </p>
                  </b-form-group>
                </validation-provider>
                <b-form-checkbox
                  id="saved-login"
                  name="saved-login"
                  v-model="isRememberMe"
                  class="d-flex saved-login text-nowrap"
                >
                  ログイン状態を保持する
                </b-form-checkbox>
                <b-button
                  type="submit"
                  variant="info"
                  class="btn-submit d-flex align-items-center justify-content-center"
                  :disabled="status.loggingIn"
                >
                  ログイン
                  <span class="material-icons material-icons-outlined">
                    keyboard_arrow_right
                  </span>
                </b-button>
                <div class="forgot-password pl-0 pb-3 d-flex justify-content-center">
                  <a
                    @click.prevent.once="gotoForgotPassword"
                    class="cursor-pointer"
                    >パスワードをお忘れの場合はこちら</a
                  >
                </div>
              </b-form>
            </validation-observer>
          </b-row>

          <!-- Forgot Password Mode -->
          <forgot-password
            v-if="isNormalLoginMode && !isLoginMode && !confirmCodeMode"
            v-on:verify-email="onClickForgotPassword"
            v-on:back-to-login="backToLogin"
          >
          </forgot-password>

          <!-- Confirm Code Mode -->
          <verify-code
            v-if="isNormalLoginMode && !isLoginMode && confirmCodeMode"
            v-on:verify-code="onClickConfirmCode"
            v-on:back-to-login="backToLogin"
          >
          </verify-code>
        </b-container>
      </b-col>
    </b-row>
    <!-- NickName requirement area -->
    <b-modal
      ref="nickname-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      centered
      size="sm"
    >
      <b-container
        class="d-flex flex-column justify-content-between align-items-center"
      >
        <p>よろしくおねがいします</p>
        <p class="mb-0">名前</p>
        <input-text-component
          id="nickname"
          v-model="nickName"
          classCustom="align-middle"
          :maxlength="30"
          @blur="cleanValidity('nickname')"
        />
        <div class="w-100">
          <span class="character-counting">{{ nickNameCharacterCount }}</span>
        </div>

        <p class="text-center">さん</p>
        <b-container class="w-100 container d-flex justify-content-center">
          <b-button
            v-show="nickName.length !== 0"
            class="btn-submit"
            variant="info"
            @click="setNickname"
            v-on:keyup.enter="setNickname"
            type="submit"
            >はじめる</b-button
          >
        </b-container>
      </b-container>
    </b-modal>
  </main>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapState, mapActions, mapGetters } from 'vuex'
import FlashMessage from '../common/flash-message.component'
import { mediaService, userService } from './../_services'
import VerifyCode from './user-info/VerifyCode.vue'
import ForgotPassword from './user-info/ForgotPassword.vue'
import RouterUtils from '../_helpers/router.util'
import AlertMessageComponent from './custom-components/AlertMessageComponent.vue'
import InputTextComponent from './custom-components/InputTextComponent.vue'
import ConfigUtils from '../common/config-utils'
import { loginRequest, popupWindowAttributes } from '../entra-login/entra.config'
import { authService } from '../_services/auth.service'
import Loading from 'vue-loading-overlay'
import AppConstants from '../constants/app.constants'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VerifyCode,
    ForgotPassword,
    AlertMessageComponent,
    InputTextComponent,
    Loading
  },
  async mounted() {
    this.posts = await mediaService.getTopMedia()
    this.updateMenuStatus(0)
  },
  data() {
    return {
      submitted: false,
      slide: 0,
      form: {
        username: '',
        password: '',
        email: '',
        confirmCode: ''
      },
      posts: [
        {
          postImg: require('@/assets/images/default_img.jpeg'),
          title: 'ページ読み込み中です。しばらくお待ちください。',
          category: 'ページ読み込み中です。しばらくお待ちください。',
          content: 'ページ読み込み中です。しばらくお待ちください。',
          avatar: require('@/assets/images/default_img.jpeg'),
          published_date: '',
          author: ''
        }
      ],
      isRememberMe: false,
      nickName: '',
      isLoginMode: true,
      confirmCodeMode: false,
      isNormalLoginMode: false,
      isLoading: false
    }
  },
  computed: {
    ...mapState('auth', ['status', 'user']),
    ...mapGetters['checkPassword/getChangePasswordFlag'],
    nickNameCharacterCount() {
      return `${this.nickName.length}/30`
    }
  },
  methods: {
    ...mapActions('auth', ['login', 'updateNickname', 'confirmCodeFromEmail', 'verifyEntraLogin']),
    ...mapGetters('auth', ['getUserDetails']),
    ...mapActions('flashMessage', ['removeAllErrorMessages']),
    ...mapActions('checkPassword', ['checkUserId']),
    ...mapGetters('checkPassword', ['getcheckPasswordMode']),
    ...mapActions('settingWizardStore', ['updateMenuStatus']),
    async onClickLogin() {
      const isValid = await this.$refs.validationLoginForm.validate()
      if (!isValid) {
        FlashMessage.getInstance().hideAllMessages()
        return
      }
      this.submitted = true
      const { username, password } = this.form
      if (username && password) {
        const loggedIn = await this.login({
          username,
          password,
          isRememberMe: this.isRememberMe
        }).catch(error => {
          FlashMessage.getInstance().showErrorMessage(error)
        })
        if (loggedIn) {
          this.updateMenuStatus(0)
          // Authenticate successfully => redirect to home page
          const userDetails = this.getUserDetails()
          if (userDetails.nickName) {
            for (let idx = 0; idx < this.getcheckPasswordMode().length; idx++) {
              const elm = this.getcheckPasswordMode()[idx]
              if (elm && userDetails && elm.userId === userDetails.userId && elm.changePasswordFlag) {
                RouterUtils.goToRouterName('Change Password')
                return
              }
            }
            RouterUtils.goToRouterName('Dashboard')
          } else this.$refs['nickname-modal'].show()
        }
      }
    },
    async setNickname() {
      const res = await this.updateNickname({ nickName: this.nickName })
      if (res) {
        // Update nickname successfully
        this.$refs['nickname-modal'].hide()
        RouterUtils.goToRouterName('Dashboard')
      }
    },
    async onClickForgotPassword(verifyEmail) {
      this.$set(this.form, 'email', verifyEmail)
      this.isLoginMode = false
      const { email } = this.form
      const res = await userService.postSendVerifyEmail(email).catch(error => {
        FlashMessage.getInstance().showErrorMessage(String(error).replace('Error:', ''))
      })
      if (!res) {
        this.confirmCodeMode = false
        return
      }
      if (res.code === 200) {
        this.confirmCodeMode = true
        FlashMessage.getInstance().hideAllErrorMessages()
      }
    },
    async onClickConfirmCode(verifyCode) {
      this.$set(this.form, 'confirmCode', verifyCode)
      const { confirmCode, email } = this.form
      await this.confirmCodeFromEmail({ confirmCode, email }).catch((error) => {
        FlashMessage.getInstance().showErrorMessage(String(error).replace('Error:', ''))
      })
      this.updateMenuStatus(0)
      RouterUtils.goToRouterName('Change Password')
      const plusaUser = JSON.parse(localStorage.getItem('plusa-user'))
      const userConfirmCode = {
        userId: plusaUser && plusaUser.userId,
        changePasswordFlag: true
      }
      this.checkUserId(userConfirmCode)
    },
    backToLogin() {
      // back to initiate state
      FlashMessage.getInstance().hideAllErrorMessages()
      this.isLoginMode = true
      this.confirmCodeMode = false
    },
    gotoForgotPassword() {
      FlashMessage.getInstance().hideAllErrorMessages()
      this.isLoginMode = false
    },
    openLink(index) {
      let openLink = this.posts[index].link
      window.open(openLink, '_blank')
    },
    prev() {
      this.$refs.carousel.prev()
    },
    next() {
      this.$refs.carousel.next()
    },
    cleanValidity(id) {
      const input = document.getElementById(id)
      if (!input.checkValidity()) {
        input.setCustomValidity('')
      }
    },

    /**
     * Entraアカウントでログインします。
     */
    async onClickLoginWithEntra() {
      try {
        this.isLoading = true
        const loginResponse = await this.$msalInstance.loginPopup(loginRequest, popupWindowAttributes)
        const activeAccount = loginResponse?.account
        const entraTenantId = ConfigUtils.getConfigByKey('MSAL_TENANT_ID')
        const accessToken = loginResponse?.accessToken
        const isVerifiedLogin = await this.verifyEntraLogin({
          accessToken: accessToken,
          tenantId: entraTenantId
        }).catch(async (error) => {
          await authService.handleEntraLogout(activeAccount).catch(err => console.error(err))
          FlashMessage.getInstance().showErrorMessage(error)
          return false
        })
        if (isVerifiedLogin) {
          localStorage.setItem(AppConstants.STORAGE_LOGIN_TIMESTAMP, new Date().getTime().toString())
          this.updateMenuStatus(0)
          RouterUtils.goToRouterName('Dashboard')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },

    /**
     * システムアカウントでログインモードを切り替えます。
     */
    handleSysLoginMode() {
      this.isNormalLoginMode = !this.isNormalLoginMode
      if (this.isLoginMode) {
        this.form.username = ''
        this.form.password = ''
      } else {
        this.form.email = ''
        this.form.confirmCode = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  position: absolute;
  width: 100vw;
  height: 100vh;

  @media (max-width: 949.5px) {
    .main-content{
      overflow: auto;
    }
    .left-container {
      order: 2;
    }
    .right-container {
      order: 1;
    }
  }
  /deep/ .custom-control-label {
    display: flex;
    align-items: center;
  }
  .text_gray {
    color: #666563;
    @include responsive-fs(12);
  }
  .text_black {
    color: #252422;
    @include responsive-fs(12);
  }
  .text_blue {
    color: #155275 !important;
    @include responsive-fs(12);
  }

  /* Right container */
  .logo {
    width: 140px;
    height: 60px;
    margin-bottom: 40px;
  }
  .form-group input {
    border: 1px solid #afafae;
    height: 38px;
  }
  .btn-submit {
    width: 100%;
    height: 42px;
    margin-top: 10px;
  }
  .forgot-password {
    margin-top: 20px;
    @include responsive-fs(12);
    a {
      color: #155275;
    }
  }
  .saved-login input label {
    @include responsive-fs(12);
    vertical-align: middle;
  }
  .custom-control {
    @include responsive-fs(14);
  }
  /* Rigth container */
  .right-container {
    flex: 1 1 40vw;
    min-width: 380px;
  }
  /* Left container */
  .left-container {
    background-image: url(../assets/images/login/left_retangles.svg),
      url(../assets/images/login/right_retangles.svg);
    background-repeat: repeat-y, repeat-y;
    background-position: left, right;
    background-size: 192px 984px;
    flex: 1 1 60vw;
  }
  .main-header {
    @include responsive-fs(24);
  }
  .sub-header {
    @include responsive-fs(16);
  }
  .carousel-control-next {
    left: 96%;
  }
  .carousel-control-next-icon {
    background-image: url(../assets/images/login/next-btn.svg);
    background-size: 40px 40px;
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
  }

  .carousel-control-prev {
    left: -11%;
  }
  .carousel-control-prev-icon {
    background-image: url(../assets/images/login/previous-btn.svg);
    width: 40px;
    height: 40px;
  }
  .carousel,
  slide-area,
  slide {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.12) !important;
  }
  .post-profile,
  .post-info,
  .post-logo,
  .author-img {
    padding-left: 0px;
    padding-right: 0px;
  }
  .post-info p {
    margin: 0px;
  }
  .post-info {
    margin-left: 0px;
    margin-right: 0px;
  }
  .author-img img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  .image-container {
    width: 272px;
    height: 272px;
  }

  .slide-image.img-fluid {
    max-height: 272px;
  }
  .btn-carousel {
    width: 40px;
    height: 40px;
    background-color: #ffffff;
    box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.12) !important;
    border-radius: 4px;
  }

  .btn-carousel i {
    color: #4e66a6;
  }

  .btn-info {
    background-color: #4e66a6;
  }
  .error-message {
    @include responsive-fs(12);
    line-height: 160%;
    color: #b41b3e;
  }
  .text-size-12 {
    @include responsive-fs(12);
  }
  .post-title h6 {
    width:100%;
    /* white-space: pre-wrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
     display: -webkit-box;
  }
  .post-title h6 {
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
     display: -webkit-box;
  }
  .content p {
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
     display: -webkit-box;
  }
  @media (max-width: 767px) {
    .content p {
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
     display: -webkit-box;
  }
  }
  .slide-y-enter-active,
  .slide-y-leave-active {
    transition: all 0.3s ease;
    overflow: hidden;
  }

  .slide-y-enter-from,
  .slide-y-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-100px);
  }

  .slide-y-enter-to,
  .slide-y-leave-from {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0);
  }
  .normal-login {
    display: flex;
    align-items: center;
    margin-top: 2rem;
    width: max-content;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue